//由于服务端没有存储点赞，follow状态，这里存储一些本地状态，用于优化用户体验
"use client"
import { create } from "zustand";
import { persist } from "zustand/middleware";
const STORAGE_KEY = "status-storage";
type StatusStore = {
    likedDocList: string[];
    followedUserList: string[];
    setLikedDocList: (likedDocList: string[]) => void;
    clearLikedDocList: () => void;
    clearFollowedUserList: () => void;
    setFollowedUserList: (followedUserList: string[]) => void;
    loginModalVisible: boolean;
    setLoginModalVisible: (loginModalVisible: boolean) => void;
}

const useStatusStore = create<StatusStore>()(
    persist(
        (set) => ({
            likedDocList: [],
            followedUserList: [],
            setLikedDocList: (likedDocList: string[]) => set({ likedDocList }),
            clearLikedDocList: () => set({ likedDocList: [] }),
            clearFollowedUserList: () => set({ followedUserList: [] }),
            setFollowedUserList: (followedUserList: string[]) => set({ followedUserList }),
            loginModalVisible: false,
            setLoginModalVisible: (loginModalVisible: boolean) => set({ loginModalVisible }),
        }),
        {
            name: STORAGE_KEY,
            partialize: (state) => ({
                likedDocList: state.likedDocList,
                followedUserList: state.followedUserList,
            }),
        }
    )
)

export default useStatusStore;